import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// Super-admin only. payload: { name, managerId, memberIds[], notes }
export const createRealEstateTeamApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/real-estate-teams`, payload);

export const updateRealEstateTeamApi = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/real-estate-teams/${id}`, payload);

// Deactivates (reports are kept).
export const deactivateRealEstateTeamApi = (id) =>
  axios.delete(`${API_BASE_URL}/api/real-estate-teams/${id}`);
